/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use client';

import { registerAsset, getAssetByID } from '../../modules/AssetRegistry';
var AssetRegistry = {
  registerAsset,
  getAssetByID
};
export default AssetRegistry;